import React from 'react';
import { withStyles, Grid, Hidden } from '@material-ui/core';
import SolidBackdrop from '../misc/SolidBackdrop';
import HeadlineText from '../misc/HeadlineText';
import DescriptionText from '../misc/DescriptionText';
import VideoCard from '../misc/VideoCard';
import { shuffle } from '../../../utilities/randomUtilities';
import ArrowButton from '../misc/ArrowButton';
import Link from '../misc/Link';
import theme from '../../theme';
import ExamplesConstants from '../examples/ExamplesConstants';
import { trackEvent, AnalyticsConstants } from '../../../utilities/analyticsUtilities';

const styles = theme => ({
    section: {
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(4)
		},
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(8) * 1.5}px 0`
        },
        marginTop: 0,
        marginBottom: 0,
        zIndex: 1
    },
    videosItem: {
        width: '100%',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4)
    }
});

class IndexExamplesSection extends React.Component {
    state = {
        videoData: []
    }

	render() {
        const { classes } = this.props;

		return (
            <Grid
                container
                alignItems='center'
                justify='center'
                spacing={4}
                className={classes.section}
                direction='column'
            >
                <SolidBackdrop
                    image='https://specterr.b-cdn.net/bg-wave2.svg'
                    color={theme.palette.background.darker2}
                    shadow
                />
                <Grid item>
                    <HeadlineText align='center'>
                        Stunning Music Visualizers & Lyric Videos
                    </HeadlineText>
                </Grid>
                <Grid item>
                    <DescriptionText>
                        Get started with one of our visualizer presets. Audio visualizers can be heavily customized to fit your brand.
                    </DescriptionText>
                </Grid>
                <Grid 
                    item 
                    className={classes.videosItem}
                >
                    <Grid
                        container
                        alignItems='center'
                        justify='center'
                        spacing={10}
                        direction='row'
                    >
                        {this.videoCardList('Edit Now', 2)}
                    </Grid>
                </Grid>
                <Grid item>
                    <Link
                        to='/music-visualizer/#presets'
                        underline='none'
                        onClick={() => {
                            trackEvent('Clicked CTA', {
                                location: 'home examples',
                                destination: 'music-visualizer presets',
                                color: 'red',
                                text: 'SEE MORE VISUALIZERS',
                                type: 'button',
                                category: AnalyticsConstants.ACQUISITION_CATEGORY
                            });
                        }}
                    >
                        <ArrowButton
                            color='primary'
                            variant='outlined'
                            size='large'
                        >
                            See More Visualizers
                        </ArrowButton>
                    </Link>
                </Grid>
            </Grid>
		);
    }
    
    componentDidMount() {
        this.setState({videoData: shuffle(ExamplesConstants.PRESET_VIDEOS.slice()).slice(0,3)});
    }

    videoCardList = (videoButtonText, smHiddenIndex) => {
        const { videoData } = this.state;

        return videoData.map((video, i) => {
            const videoCard = <Grid item xs={12} sm={6} md={4} key={i}>
                <VideoCard
                    thumbnailUrl={video.thumbnailUrl}
                    videoUrl={video.videoUrl}
                    name={video.name}
                    buttonText={videoButtonText}
                    buttonHref={video.buttonHref}
                />
            </Grid>

            if (i >= smHiddenIndex) {
                return <Hidden smDown key={i}>{videoCard}</Hidden>
            }

            return videoCard
        });
    }
}

export default withStyles(styles)(IndexExamplesSection);